import { SVGProps, JSX } from 'react';
import {
  Calculator,
  FileSearch2,
  MessageSquare,
  FileText,
  Cancel,
} from '@huspy/briks-icons';
import { BankApplicationStatus } from '@modules/opportunities/entities/bankApplication/bankApplication.entity';
import { OpportunityStatus } from '@modules/opportunities/entities/opportunity/opportunity.entity';
import { bankApplicationStatusMapper } from '@modules/opportunities/mappers/bankApplicationStatusMapper';
import { OPPORTUNITY_STATUS } from '@modules/opportunities/entities/opportunity/const';
import { BANK_APPLICATION_STATUS } from '@modules/opportunities/entities/bankApplication/const';
import { Flex, Text } from '@huspy/briks-web';

type StatusTagType = {
  status: BankApplicationStatus | OpportunityStatus;
};

export const StatusTag = ({ status }: StatusTagType) => {
  const { text, color } = bankApplicationStatusMapper(status);

  const colorMap = {
    green: { fgColor: '#2EC4A0', bgColor: '#EAF9F6' },
    purple: { fgColor: '#2655F5', bgColor: '#F1F6FF' },
    neutral: { fgColor: '#525763', bgColor: '#F4F6F9' },
    red: { fgColor: '#E33C5A', bgColor: '#FCECEF' },
  };

  const colors = colorMap[color];

  type IconMap = Record<
  BankApplicationStatus | OpportunityStatus,
  ((props: SVGProps<SVGSVGElement>) => JSX.Element) | null
  >;
  const iconMap: IconMap = {
    [OPPORTUNITY_STATUS.draft]: null,
    [OPPORTUNITY_STATUS.new]: FileSearch2,
    [OPPORTUNITY_STATUS.inProgress]: FileSearch2,
    [OPPORTUNITY_STATUS.onHold]: null,
    [OPPORTUNITY_STATUS.lost]: null,
    [BANK_APPLICATION_STATUS.draft]: null,
    [BANK_APPLICATION_STATUS.docsReview]: FileSearch2,
    [BANK_APPLICATION_STATUS.fillForms]: null,
    [BANK_APPLICATION_STATUS.docsReadyToSend]: null,
    [BANK_APPLICATION_STATUS.bankSubmission]: null,
    [BANK_APPLICATION_STATUS.salesQueries]: null,
    [BANK_APPLICATION_STATUS.salesSubmittedToCredit]: null,
    [BANK_APPLICATION_STATUS.creditQueries]: MessageSquare,
    [BANK_APPLICATION_STATUS.preApproved]: null,
    [BANK_APPLICATION_STATUS.propertySelection]: null,
    [BANK_APPLICATION_STATUS.valuation]: Calculator,
    [BANK_APPLICATION_STATUS.fol]: FileText,
    [BANK_APPLICATION_STATUS.folSigned]: null,
    [BANK_APPLICATION_STATUS.finalDocs]: null,
    [BANK_APPLICATION_STATUS.notProceeding]: Cancel,
    [BANK_APPLICATION_STATUS.approved]: null,
    [BANK_APPLICATION_STATUS.onHold]: null,
    [BANK_APPLICATION_STATUS.declined]: null,
    [BANK_APPLICATION_STATUS.disbursed]: null,
    [BANK_APPLICATION_STATUS.propertyTransferred]: null,
  };

  const Icon = iconMap[status];

  return (
    <Flex
      style={ { backgroundColor: colors.bgColor, width: 'fit-content' } }
      borderRadius={ 999 }
      gap='1'
      direction='row'
      py='1'
      px='4'
      align='center'
    >
      {Icon && <Icon color={ colors.fgColor } />}
      <Text
        color={ colors.fgColor }
        style={ { color: colors.fgColor, textWrap: 'nowrap' } }
        size='sm'
        fontWeight='medium'
      >
        {text}
      </Text>
    </Flex>
  );
};
